import { render } from "./Index.vue?vue&type=template&id=d7784b90"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/NotFound/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7784b90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7784b90', __exports__)) {
    api.reload('d7784b90', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=d7784b90", () => {
    api.rerender('d7784b90', render)
  })

}


export default __exports__